import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import axios from "axios";

// Login Redux States
import { CHECK_LOGIN, LOGOUT_USER } from "./actionTypes";
import { apiError, loginUserSuccessful, logoutUserSuccess } from "./actions";

// AUTH related methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
// import { post } from "./../../../helpers/api_helper";

//Initilize firebase
const fireBaseBackend = getFirebaseBackend();

const API_URL = process.env.API_BASE_URL;

//If user is login then dispatch redux action's are directly from here.
function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(() =>
      axios.post(`${API_URL}/login`, {
        email: user.email,
        password: user.password,
      })
    );

    localStorage.setItem("authUser", JSON.stringify(response.data));

    yield put(loginUserSuccessful(response.data));

    history("/dashboard");
  } catch (error) {
    console.error("Login Error:", error);
    yield put(apiError(error.response?.data || error.message));
  }
}


function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }

    history("/login");
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchUserLogin() {
  yield takeEvery(CHECK_LOGIN, loginUser);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}

function* loginSaga() {
  yield all([fork(watchUserLogin), fork(watchUserLogout)]);
}

export default loginSaga;
